<template>
  <div class="v-Login">
    <cube-popup :visible.sync="visible" ref="myPopup" type="my-popup">
      <div class="popup">
        <img @click="close" alt class="close" src="../../images/close.png" />
        <v-login @change="change" @success="loginSuccess" ref="login" v-show="state === 0"></v-login>
        <v-register @change="change" @success="registerSuccess" ref="register" v-show="state !== 0"></v-register>
      </div>
    </cube-popup>
  </div>
</template>
<script>
import vLogin from './components/login'
import vRegister from './components/register'
export default {
  data() {
    return {
      state: 0
    }
  },
  components: {
    vLogin,
    vRegister
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.group.loginVisible
      },
      set(val) {
        this.$store.commit('group/setLoginVisible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 显示隐藏，下面state不会触发
        if(this.state === 0) {
          this.$refs.login.reset()
        } else {
          this.state = 0
        }
      }
    },
    state(val) {
      if (val === 0) {
        this.$refs.login.reset()
      } else {
        this.$refs.register.reset()
      }
    }
  },
  methods: {
    close() {
      this.$store.commit('group/setLoginVisible', false)
    },
    getUser() {
      this.$groupGet('auth/userInfo').then(data => {
        if (data.errCode === 0) {
          this.$store.commit('group/setUserInfo', data.data)
        }
      })
    },
    loginSuccess() {
      this.getUser()
      this.close()
    },
    registerSuccess() {
      this.state = 0
    },
    change(val) {
      this.state = val
    }
  },
  created() {
    if (this.$hasGroupAuthorization()) {
      this.getUser()
    }
  }
}
</script>
<style lang="scss" scoped>
.cube-popup {
  position: absolute;
  overflow: hidden;
}
.popup {
  position: relative;
  background: #fff;
  padding: 40px;
  box-sizing: border-box;
  width: 570px;
  border-radius: 20px;
  font-size: 28px;
  .close {
    position: absolute;
    width: 58px;
    height: 58px;
    top: -22px;
    right: -22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/group/components/login/index.vue